import * as React from 'react';
import { useCallback, useEffect, useState } from 'react';
import { Collapse, Container, DropdownItem, DropdownMenu, DropdownToggle, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink, UncontrolledDropdown } from 'reactstrap';
import { Link, NavLink as RRNavLink, useLocation  } from 'react-router-dom';
import { LoginMenu } from './api-authorization/LoginMenu';
import './NavMenu.css';
import useAppRoutes from '../AppRoutes';
import BeheerMenu from './BeheerMenu';


const NavMenu = () => {
	const routePaths = useAppRoutes();
    const [expanded, setExpanded] = useState(false);

	const { pathname } = useLocation();

	//collapse menu when changing react route.
	useEffect(() => { pathname && setExpanded(false) }, [pathname]);

    const toggleNav = useCallback(() => setExpanded(p => !p), [])

	return <header>
		<Navbar className="navbar-expand-md navbar-toggleable-md ng-white border-bottom box-shadow mb-3" light fixed='top' color="light" > 
            <Container>
                <NavbarBrand tag={Link} to="/">Visitatieraad sociale huisvestingsmaatschappijen</NavbarBrand>
                <NavbarToggler onClick={toggleNav} className="mr-2" />
                <Collapse className="d-md-inline-flex flex-md-row-reverse" isOpen={expanded} navbar>
                    <ul className="navbar-nav flex-grow">
                        <NavItem>
							<NavLink tag={Link} to="/">Home</NavLink>
                        </NavItem>

						<UncontrolledDropdown nav inNavbar>
							<DropdownToggle nav caret>Zoeken</DropdownToggle>
							<DropdownMenu right>
								<DropdownItem>
									<NavLink
										tag={RRNavLink}
										activeClassName="active"
										exact to={routePaths.zoekGoedePraktijken}>Goede praktijken
									</NavLink>
								</DropdownItem>
								<DropdownItem>
									<NavLink
										tag={RRNavLink}
										activeClassName="active"
										exact to={routePaths.zoekRapporten}>Visitatierapporten
									</NavLink>
								</DropdownItem>
								<DropdownItem>
									<NavLink
										tag={RRNavLink}
										activeClassName="active"
										exact to={routePaths.zoekShmPrestaties}>SHM met goede of uitstekende prestaties
									</NavLink>
								</DropdownItem>								
							</DropdownMenu>
						</UncontrolledDropdown>

                        <BeheerMenu />
                        <LoginMenu />
                         
                    </ul>
                </Collapse>
            </Container>
        </Navbar>
    </header>
}
export default NavMenu;